import type { ResponseWithType, SessionResponse } from './types';
import type { Session } from '../../types/session';

const sessionResponse = ({ data }: ResponseWithType<Session>): SessionResponse => {
  return {
    __typename: 'SessionResponse',
    ...data,
  };
};

export default sessionResponse;
